import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Dialog, DialogTitle, IconButton, withStyles } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import Loading from "../../../../components/Loading/Loading";
import { RedtailImportContacts, RedtailLogin } from "./components";

const styles = (theme) => ({
  header: {
    "& h2": {
      fontSize: theme.typography.body2.fontSize,
      lineHeight: theme.typography.base.lineHeight,
      display: "flex",
      flexFlow: "row nowrap",
      justifyContent: "space-between",
      alignItems: "center",
    },
  },
});

const ImportClientModal = ({ classes, isOpen, onClose }) => {
  const [requesting, loggedIn] = useSelector(({ redtail }) => [
    redtail.requesting,
    redtail.loggedIn,
  ]);
  const hasRedtailIntegration = useSelector(
    ({ user }) => user.user.hasRedtailIntegration
  );

  const isAccountLinked = hasRedtailIntegration || loggedIn;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth={true}
      maxWidth="xl"
      aria-labelledby="import-client-modal-title"
      aria-describedby="import-client-modal-description"
    >
      <DialogTitle id="import-client-modal-title" className={classes.header}>
        {isAccountLinked ? "Import Contacts" : "Sign in to Redtail CRM"}
        <IconButton aria-label="Close" onClick={onClose}>
          <Close color="primary" />
        </IconButton>
      </DialogTitle>
      <React.Fragment>
        {requesting && <Loading />}
        {isAccountLinked ? (
          <RedtailImportContacts onClose={onClose} />
        ) : (
          <RedtailLogin />
        )}
      </React.Fragment>
    </Dialog>
  );
};

ImportClientModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

ImportClientModal.defaultProps = {
  isOpen: false,
};

export default withStyles(styles)(ImportClientModal);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/components/ImportClientModal/index.jsx